export default {
  info:    0,
  payment: 1,
  success: 2
};
